import type { OrganizationTreeNode } from '../hooks/useOrganizationsTree'

/**
 * Finds the path from root to a target node in the organization tree.
 * Returns an array of node IDs from root to target, or null if not found.
 *
 * @param nodes - Array of tree nodes to search
 * @param targetId - The ID of the node to find
 * @returns Array of node IDs representing the path, or null if not found
 */
export function findNodePath(
  nodes: OrganizationTreeNode[],
  targetId: string
): string[] | null {
  for (const node of nodes) {
    if (node.id === targetId) {
      return [node.id]
    }

    if (node.children && node.children.length > 0) {
      const childPath = findNodePath(node.children, targetId)
      if (childPath) {
        return [node.id, ...childPath]
      }
    }
  }

  return null
}
